import { useState } from 'react';

import { Heading } from '@frontendmentorio/design-system-v2';

import Images from './Images';
import Step from './Step';

export default function HowItWorks() {
  const [activeStep, setActiveStep] = useState(1);

  return (
    <div className="px-5">
      <div className="bg-gray-100 overflow-hidden rounded-xl">
        <div className="container-sm flex flex-col gap-6 px-5 py-8 desktop:container-xl desktop:py-9">
          <Heading level="3" tagName="h2">
            How it works
          </Heading>

          <div className="flex flex-col gap-6 items-center desktop:flex-row-reverse desktop:items-start">
            <Images activeStep={activeStep} />

            <div className="flex flex-col gap-4 desktop:w-1/2">
              <Step
                step={1}
                heading="Choose your challenge"
                isActive={activeStep === 1}
                onClick={() => setActiveStep(1)}
              >
                Pick from 100+ professionally designed projects across five
                skill levels—from HTML/CSS basics to full-stack applications.
              </Step>

              <Step
                step={2}
                heading="Code the design"
                isActive={activeStep === 2}
                onClick={() => setActiveStep(2)}
              >
                Build responsive websites and web apps using the provided
                designs as your guide. Practice with any tools, frameworks, or
                AI assistants you want to master.
              </Step>

              <Step
                step={3}
                heading="Submit and improve"
                isActive={activeStep === 3}
                onClick={() => setActiveStep(3)}
              >
                Get automated feedback, community code reviews, and compare your
                solution to the design. Refine your approach and level up with
                each project.
              </Step>

              <Step
                step={4}
                heading="Help others grow"
                isActive={activeStep === 4}
                onClick={() => setActiveStep(4)}
              >
                Review other developers' code to sharpen your skills and build
                connections in our supportive community.
              </Step>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
